<div class="pt-8 pb-8" *ngIf="(tenantData?.cloudProvider === 'Azure' || tenantData?.targetCloud === 'Azure');else awsSubscription">
    <div class="flex flex-row fw-600 fs-16">
        <img class="icon-lg mr-8 mb-24" src="/assets/images/Frame.png" />{{'TENANT_DETAILS.MICROSOFT_AZURE' | transloco}}
    </div>
    <div class="flex flex-row solutions-container p-8">
        <fieldset *ngIf="subscriptionIdNonPii; else noDataReCreateTest" class="solution-tile p-22 mr-2">
            <legend class="datazone fw-600 subscription-nonprod">{{'TENANT_LIST.NON_PII' | transloco}}</legend>
            <div class="label-text flex mt-4">
                <span class="fs-16 fw-600 m-0 solution-heading">{{'TENANT_DETAILS.SUBSCRIPTION_NAME' | transloco}}</span>
                <span class="fs-16 fw-400 m-0 mb-10 subscription-font pl-30">{{subscriptionNameNonPii ? subscriptionNameNonPii : '--'}}</span>
            </div>
            <div class="flex flex-row items-center pt-28">
                <span class="fs-16 fw-600 m-0 solution-heading">{{'TENANT_DETAILS.SUBSCRIPTION_ID' | transloco}}</span>
                <span class="flex flex-row pl-54">
                    <mat-icon class="mr-6 cursor-pointer" svgIcon="open_in_new" (click)="openUrl(subscriptionIdNonPii)">
                    </mat-icon>
                    <span class="overview-values fs-16 fw-400 edit_hover_class m-0 mb-0 subscription-font">
                        <a href="javascript:void(0);" (click)="openUrl(subscriptionIdNonPii)" class="no-underline">{{subscriptionIdNonPii ? subscriptionIdNonPii : '--'}}</a>
                        <mat-icon *ngIf="subscriptionIdNonPii" class="h-18 w-18 mr-6" [ngClass]="[copy ? 'copied': 'copy']" [svgIcon]="copy ? 'check' : 'content_copy'" (click)="onCopyId(subscriptionIdNonPii)"></mat-icon>
                    </span>
                </span>
            </div>
        </fieldset>
    </div>
    <div class="flex flex-row solutions-container p-8">
        <fieldset *ngIf="subscriptionIdPii; else noDataReCreatePii" class="solution-tile p-22 mr-2">
            <div class="label-text flex mt-4">
                <span class="fs-16 fw-600 m-0 solution-heading">{{'TENANT_DETAILS.SUBSCRIPTION_NAME' | transloco}}</span>
                <span class="fs-16 fw-400 m-0 mb-10 subscription-font pl-30">{{subscriptionNamePii ? subscriptionNamePii : '--'}}</span>
            </div>
            <legend class="datazone fw-600 subscription-prod">{{'TENANT_LIST.PROD' | transloco}}</legend>
            <div class="flex flex-row items-center pt-28">
                <span class="fs-16 fw-600 m-0 solution-heading">{{'TENANT_DETAILS.SUBSCRIPTION_ID' | transloco}}</span>
                <span class="flex flex-row pl-54">
                    <mat-icon class="cursor-pointer mr-6" svgIcon="open_in_new" (click)="openUrl(subscriptionIdPii)"></mat-icon>
                    <span class="overview-values fs-16 fw-400 edit_hover_class m-0 mb-0 subscription-font">
                        <a href="javascript:void(0);" (click)="openUrl(subscriptionIdPii)" class="no-underline">{{subscriptionIdPii ? subscriptionIdPii : '--'}}</a>
                        <mat-icon *ngIf="subscriptionIdPii" class="h-18 w-18 mr-6" [ngClass]="[copy ? 'copied': 'copy']" [svgIcon]="copy ? 'check' : 'content_copy'" (click)="onCopyId(subscriptionIdPii)"></mat-icon>
                    </span>
                </span>
            </div>
        </fieldset>
    </div>
</div>
<ng-template #awsSubscription>
    <div class="pt-8 pb-8">
        <div class="flex flex-row fw-600 fs-16"><img class="mr-8 mb-24 w-46" src="/assets/images/Amazon_Web_Services_Logo 1.png" />{{'TENANT_DETAILS.AMAZON_AWS' | transloco}}</div>
        <div class="flex flex-row solutions-container p-8">
            <fieldset *ngIf="accountIdNonPii; else noDataReCreateNonPii" class="solution-tile p-22 mr-2">
                <div class="label-text flex mt-4">
                    <span class="fs-16 fw-600 m-0 solution-heading">{{'TENANT_DETAILS.ACCOUNT_NAME' | transloco}}</span>
                    <span class="fs-16 fw-400 m-0 mb-10 subscription-font pl-30">{{accountNameNonPii ? accountNameNonPii : '--'}}</span>
                </div>
                <legend class="datazone fw-600 subscription-nonprod">{{'TENANT_LIST.NON_PII' | transloco}}</legend>
                <div class="flex flex-row items-center pt-12">
                    <span class="fs-16 fw-600 m-0 solution-heading">{{'TENANT_DETAILS.ACCOUNT_ID' | transloco}}</span>
                    <span class="overview-values fs-16 fw-400 edit_hover_class m-0 mb-0 subscription-font pl-54">{{accountIdNonPii ? accountIdNonPii : '--'}}
                        <mat-icon *ngIf="accountIdNonPii" class="h-18 w-18 mr-6" [ngClass]="[copy ? 'copied': 'copy']" [svgIcon]="copy ? 'check' : 'content_copy'" (click)="onCopyId(accountIdNonPii)"></mat-icon>
                    </span>
                </div>
                <div class="flex flex-row items-center pt-20">
                    <span class="fs-16 fw-600 m-0 solution-heading">{{'TENANT_DETAILS.ACCOUNT_EMAIL' | transloco}}</span>
                    <span class="overview-values fs-16 fw-400 edit_hover_class m-0 mb-0 subscription-font pl-30">{{accountEmailNonPii ? accountEmailNonPii : '--'}}
                        <mat-icon *ngIf="accountEmailNonPii" class="h-18 w-18 mr-6" [ngClass]="[copy ? 'copied': 'copy']" [svgIcon]="copy ? 'check' : 'content_copy'" (click)="onCopyId(accountEmailNonPii)"></mat-icon>
                    </span>
                </div>
            </fieldset>
        </div>
         <div class="flex flex-row solutions-container p-8">
            <fieldset *ngIf="accountIdNonProdPii; else noDataReCreateNonProdPii" class="solution-tile p-22 mr-2">
                <div class="label-text flex mt-4">
                    <span class="fs-16 fw-600 m-0 solution-heading">{{'TENANT_DETAILS.ACCOUNT_NAME' | transloco}}</span>
                    <span class="fs-16 fw-400 m-0 mb-10 subscription-font pl-30">{{accountNameNonProdPii ? accountNameNonProdPii : '--'}}</span>
                </div>
                <legend class="datazone fw-600 subscription-nonprod">{{'TENANT_LIST.PII_NONPROD' | transloco}}</legend>
                <div class="flex flex-row items-center pt-12">
                    <span class="fs-16 fw-600 m-0 solution-heading">{{'TENANT_DETAILS.ACCOUNT_ID' | transloco}}</span>
                    <span class="overview-values fs-16 fw-400 edit_hover_class m-0 mb-0 subscription-font pl-54">{{accountIdNonProdPii ? accountIdNonProdPii : '--'}}
                        <mat-icon *ngIf="accountIdNonProdPii" class="h-18 w-18 mr-6" [ngClass]="[copy ? 'copied': 'copy']" [svgIcon]="copy ? 'check' : 'content_copy'" (click)="onCopyId(accountIdNonProdPii)"></mat-icon>
                    </span>
                </div>
                <div class="flex flex-row items-center pt-20">
                    <span class="fs-16 fw-600 m-0 solution-heading">{{'TENANT_DETAILS.ACCOUNT_EMAIL' | transloco}}</span>
                    <span class="overview-values fs-16 fw-400 edit_hover_class m-0 mb-0 subscription-font pl-30">{{accountEmailNonProdPii ? accountEmailNonProdPii : '--'}}
                        <mat-icon *ngIf="accountEmailNonProdPii" class="h-18 w-18 mr-6" [ngClass]="[copy ? 'copied': 'copy']" [svgIcon]="copy ? 'check' : 'content_copy'" (click)="onCopyId(accountEmailNonProdPii)"></mat-icon>
                    </span>
                </div>
            </fieldset>
        </div>
        <div class="flex flex-row solutions-container p-8">
            <fieldset *ngIf="accountIdProdPii; else noDataReCreateProdPii" class="solution-tile p-22 mr-2">
                <div class="label-text flex mt-4">
                    <span class="fs-16 fw-600 m-0 solution-heading">{{'TENANT_DETAILS.ACCOUNT_NAME' | transloco}}</span>
                    <span class="fs-16 fw-400 m-0 mb-10 subscription-font pl-30">{{accountNameProdPii ? accountNameProdPii : '--'}}</span>
                </div>

                <legend class="datazone fw-600 subscription-prod">{{'TENANT_LIST.PII_PROD' | transloco}}</legend>
                <div class="flex flex-row items-center pt-12">
                    <span class="fs-16 fw-600 m-0 solution-heading">{{'TENANT_DETAILS.ACCOUNT_ID' | transloco}}</span>
                    <span class="overview-values fs-16 fw-400 edit_hover_class m-0 mb-0 subscription-font pl-54">{{accountIdProdPii ? accountIdProdPii : '--'}}
                        <mat-icon *ngIf="accountIdProdPii" class="h-18 w-18 mr-6" [ngClass]="[copy ? 'copied': 'copy']" [svgIcon]="copy ? 'check' : 'content_copy'" (click)="onCopyId(accountIdProdPii)"></mat-icon>
                    </span>
                </div>
                <div class="flex flex-row items-center pt-20">
                    <span class="fs-16 fw-600 m-0 solution-heading">{{'TENANT_DETAILS.ACCOUNT_EMAIL' | transloco}}</span>
                    <span class="overview-values fs-16 fw-400 edit_hover_class m-0 mb-0 subscription-font pl-30">{{accountEmailProdPii ? accountEmailProdPii : '--'}}
                        <mat-icon *ngIf="accountEmailProdPii" class="h-18 w-18 mr-6" [ngClass]="[copy ? 'copied': 'copy']" [svgIcon]="copy ? 'check' : 'content_copy'" (click)="onCopyId(accountEmailProdPii)"></mat-icon>
                    </span>
                </div>
            </fieldset>
        </div>
    </div>
</ng-template>
<ng-template #noDataReCreateProdPii>
    <div class="flex flex-col solutions-container">
        <fieldset class="solution-tile-recreate p-22 mr-2">
            <legend class="pii mb-24 fw-600">{{'TENANT_LIST.PII_PROD' | transloco}}</legend>
            <div *ngIf="tenantSubscription" class="flex flex-row w-100-percent subscription-link justify-center" (click)="openSubscription()">{{'TENANT_DETAILS.GO_TO_SUBSCRIPTION' | transloco}}</div>
            <div *ngIf="permissionsMap[PermissionKeys.TENANT_ONBOARDING_DATAZONE_PII] && !tenantSubscription" class="flex w-100-percent justify-center">
                <button *ngIf="!DeployStatusProdPii" type="submit" class="accent m-12 flex flex-row h-32" (click)="onClickAddSubscription(SubscriptionTypes.AWS_PROD_PII)">
                    <mat-icon svgIcon="add" class="icon-sm mr-8 mt-4"></mat-icon>
                    <span>{{'TENANT_LIST.ADD_SUBSCRIPTION' | transloco}}</span>
                </button>
            </div>
            @if(DeployStatusProdPii) {
                <div class="flex flex-row gap-3 items-center justify-center">
                    <div class="progress-text">{{'TENANT_DETAILS.SUBSCRIPTION_PROD_PII_PROGRESS' | transloco}}</div>
                    <mat-progress-bar class="mt-2 w-120 progress-bar" mode="indeterminate"></mat-progress-bar>
                </div>
            }
        </fieldset>
    </div>
</ng-template>
<ng-template #noDataReCreateTest>
    <div class="flex flex-col solutions-container">
        <fieldset class="solution-tile-recreate p-22 mr-2">
            <legend class="datazone mb-24 fw-600">{{'TENANT_LIST.NON_PII' | transloco}}</legend>
            <div *ngIf="tenantSubscription" class="flex flex-row w-100-percent subscription-link justify-center" (click)="openSubscription()">{{'TENANT_DETAILS.GO_TO_SUBSCRIPTION' | transloco}}</div>
            <div *ngIf="((permissionsMap[PermissionKeys.TENANT_ONBOARDING_DATAZONE_NONPII]) || (permissionsMap[PermissionKeys.TENANT_ONBOARDING_DATAZONE_PII])) && !tenantSubscription" class="flex w-100-percent justify-center">
                <button *ngIf="!DeployStatusTest" type="submit" class="accent m-12 flex flex-row h-32" (click)="onClickAddSubscription(SubscriptionTypes.NONPII)">
                    <mat-icon svgIcon="add" class="icon-sm mr-8 mt-4"></mat-icon>
                    <span>{{'TENANT_LIST.ADD_SUBSCRIPTION' | transloco}}</span>
                </button>
            </div>
            @if(DeployStatusTest) {
                <div class="flex flex-row gap-3 items-center justify-center">
                    <div class="progress-text">{{'TENANT_DETAILS.SUBSCRIPTION_NON_PII_PROGRESS' | transloco}}</div>
                    <mat-progress-bar class="mt-2 w-120 progress-bar" mode="indeterminate"></mat-progress-bar>
                </div>
            }
        </fieldset>
    </div>
</ng-template>
<ng-template #noDataReCreatePii>
    <div class="flex flex-col solutions-container">
        <fieldset class="solution-tile-recreate p-22 mr-2">
            <legend class="pii mb-24 fw-600">{{'TENANT_LIST.PROD' | transloco}}</legend>
            <div *ngIf="tenantSubscription" class="flex flex-row w-100-percent subscription-link justify-center" (click)="openSubscription()">{{'TENANT_DETAILS.GO_TO_SUBSCRIPTION' | transloco}}</div>
            <div *ngIf="permissionsMap[PermissionKeys.TENANT_ONBOARDING_DATAZONE_PII] && !tenantSubscription" class="flex w-100-percent justify-center">
                <button *ngIf="!DeployStatusPii" type="submit" class="accent m-12 flex flex-row h-32" (click)="onClickAddSubscription(SubscriptionTypes.PII)">
                    <mat-icon svgIcon="add" class="icon-sm mr-8 mt-4"></mat-icon>
                    <span>{{'TENANT_LIST.ADD_SUBSCRIPTION' | transloco}}</span>
                </button>
            </div>
            @if(DeployStatusPii) {
                <div class="flex flex-row gap-3 items-center justify-center">
                    <div class="progress-text">{{'TENANT_DETAILS.SUBSCRIPTION_PROD_PROGRESS' | transloco}}</div>
                    <mat-progress-bar class="mt-2 w-120 progress-bar" mode="indeterminate"></mat-progress-bar>
                </div>
            }
        </fieldset>
    </div>
</ng-template>
<ng-template #noDataReCreateNonProdPii>
    <div class="flex flex-col solutions-container">
        <fieldset class="solution-tile-recreate p-22 mr-2">
            <legend class="datazone mb-24 fw-600">{{'TENANT_LIST.PII_NONPROD' | transloco}}</legend>
            <div *ngIf="tenantSubscription" class="flex flex-row w-100-percent subscription-link justify-center" (click)="openSubscription()">{{'TENANT_DETAILS.GO_TO_SUBSCRIPTION' | transloco}}</div>
            <div *ngIf="permissionsMap[PermissionKeys.TENANT_ONBOARDING_DATAZONE_NONPII] && !tenantSubscription" class="flex w-100-percent justify-center">
                <button *ngIf="!DeployStatusNonProdPii" type="submit" class="accent m-12 flex flex-row h-32" (click)="onClickAddSubscription(SubscriptionTypes.AWS_NON_PROD_PII)">
                    <mat-icon svgIcon="add" class="icon-sm mr-8 mt-4"></mat-icon>
                    <span>{{'TENANT_LIST.ADD_SUBSCRIPTION' | transloco}}</span>
                </button>
            </div>
            @if(DeployStatusNonProdPii) {
                <div class="flex flex-row gap-3 items-center justify-center">
                    <div class="progress-text">{{'TENANT_DETAILS.SUBSCRIPTION_NONPROD_PII_PROGRESS' | transloco}}</div>
                    <mat-progress-bar class="mt-2 w-120 progress-bar" mode="indeterminate"></mat-progress-bar>
                </div>
            }
        </fieldset>
    </div>
</ng-template>
<ng-template #noDataReCreateNonPii>
    <div class="flex flex-col solutions-container">
        <fieldset class="solution-tile-recreate p-22 mr-22">
            <legend class="datazone mb-24 fw-600">{{'TENANT_LIST.NON_PII' | transloco}}</legend>
            <div *ngIf="tenantSubscription" class="flex flex-row w-100-percent subscription-link justify-center" (click)="openSubscription()">{{'TENANT_DETAILS.GO_TO_SUBSCRIPTION' | transloco}}</div>
            <div *ngIf="permissionsMap[PermissionKeys.TENANT_ONBOARDING_DATAZONE_NONPII] && !tenantSubscription" class="flex w-100-percent justify-center">
                <button *ngIf="!DeployStatusNonPii" type="submit" class="accent m-12 flex flex-row h-32" (click)="onClickAddSubscription(SubscriptionTypes.NONPII)">
                    <mat-icon svgIcon="add" class="icon-sm mr-8 mt-4"></mat-icon>
                    <span>{{'TENANT_LIST.ADD_SUBSCRIPTION' | transloco}}</span>
                </button>
            </div>
            @if(DeployStatusNonPii) {
                <div class="flex flex-row gap-3 items-center justify-center">
                    <div class="progress-text">{{'TENANT_DETAILS.SUBSCRIPTION_NON_PII_PROGRESS' | transloco}}</div>
                    <mat-progress-bar class="mt-2 w-120 progress-bar" mode="indeterminate"></mat-progress-bar>
                </div>
            }
        </fieldset>
    </div>
</ng-template>